import { Component, OnInit, Input } from "@angular/core";
import { BvDialogService } from "../../design-system";
import { TranslateModule } from "@ngx-translate/core";
@Component({
    selector: "app-close-dialog-button",
    templateUrl: "./close-dialog-button.component.html",
    styleUrls: ["./close-dialog-button.component.scss"],
    imports: [TranslateModule]
})
export class CloseDialogButtonComponent implements OnInit {
  @Input() label!: string;
  constructor(private bvDialog: BvDialogService) {}

  ngOnInit() {}
  close() {
    this.bvDialog.closeAll();
  }
}
